// Native keyboard smooth scrolling keeps an absolute destination. Evicting an
// article changes scroll coordinates underneath that animation. Apply small
// relative steps instead, so every frame starts at the corrected position.
export function attachReaderKeyboardScroll(container, scrollAdjustmentRef, onAdvance = () => {}) {
    let frame = null;
    let remaining = 0;
    let previousTime = null;
    const stop = () => {
        if (frame !== null) window.cancelAnimationFrame(frame);
        frame = null;
        remaining = 0;
        previousTime = null;
    };
    const tick = time => {
        frame = null;
        const elapsed = previousTime === null ? 16 : Math.min(32, time - previousTime);
        previousTime = time;
        const delta = Math.abs(remaining) < 0.5 ? remaining : remaining * (1 - Math.exp(-elapsed / 60));
        const before = container.scrollTop;
        scrollAdjustmentRef.current = null;
        container.scrollTo({ top: before + delta, behavior: 'instant' });
        // Native scroll events arrive later. Measurements in this frame must
        // already see the new reading position, rather than restoring the old one.
        if (container.scrollTop !== before) onAdvance();
        remaining -= delta;
        if (Math.abs(remaining) > 0.1 && container.scrollTop !== before) {
            frame = window.requestAnimationFrame(tick);
        } else {
            stop();
        }
    };
    const onKeyDown = event => {
        if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        if (!['ArrowDown', 'ArrowUp'].includes(event.key)) {
            if (['PageDown', 'PageUp', 'Home', 'End', ' '].includes(event.key)) stop();
            return;
        }
        const target = event.target;
        if (target instanceof Element && target.closest('input,textarea,select,[contenteditable]:not([contenteditable="false"]),[role="textbox"],[role="combobox"],[role="slider"],[role="spinbutton"],[role="listbox"],[role="tree"],[role="grid"],[role="menu"],[role="tablist"]')) return;
        // A nested scrollable control keeps its own native keyboard behavior.
        for (let node = target; node instanceof Element && node !== container; node = node.parentElement) {
            if (node.scrollHeight > node.clientHeight && /^(auto|scroll)$/.test(window.getComputedStyle(node).overflowY)) return;
        }
        event.preventDefault();
        const delta = event.key === 'ArrowDown' ? 40 : -40;
        if (remaining * delta < 0) stop();
        remaining += delta;
        if (frame === null) frame = window.requestAnimationFrame(tick);
    };
    const onFocusOut = event => {
        if (!container.contains(event.relatedTarget)) stop();
    };
    container.addEventListener('keydown', onKeyDown);
    container.addEventListener('wheel', stop, { passive: true });
    container.addEventListener('touchstart', stop, { passive: true });
    container.addEventListener('pointerdown', stop, { passive: true });
    container.addEventListener('focusout', onFocusOut);
    window.addEventListener('blur', stop);
    return () => {
        stop();
        container.removeEventListener('keydown', onKeyDown);
        container.removeEventListener('wheel', stop);
        container.removeEventListener('touchstart', stop);
        container.removeEventListener('pointerdown', stop);
        container.removeEventListener('focusout', onFocusOut);
        window.removeEventListener('blur', stop);
    };
}

